module.exports = __webpack_public_path__ + "static/media/peach_0.4e055cb0.png";